import {
  Component,
  HostListener,
  Inject,
  PLATFORM_ID,
  TransferState,
  afterNextRender,
} from '@angular/core';
import {
  Subject,
  Subscription,
  debounceTime,
  first,
  firstValueFrom,
} from 'rxjs';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { ProductService } from '@/app/shared/services/product.service';
import { CommonService } from '@/app/shared/services/common.service';

import { Breadcrumb } from '@/app//shared/interface/breadcrumb';
import { Cart, CartItem } from '@/app/shared/interface/cart.interface';
import { Paginate } from '@/app/shared/interface/pagination.interface';
import {
  PaginationModel,
  Product,
  ProductModel,
  ProductsPaginationModel,
  RetriveUserModel,
} from '@/app/shared/interface/product.interface';
import { QueryStringService } from '@/app/shared/services/querystring.service';
import {
  CatetoryQueryString,
  PageQueryString,
  SearchUserQueryString,
  LabelQueryString,
} from '@/app/shared/filter';
import { FlashSaleService } from '@/app/shared/services/flashsale.service';
import { WishlistService } from '@/app/shared/services/wishlist.service';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from '@/app/shared/services/account.service';
import { Tag } from '@/app/shared/interface/tag.interface';
import { isPlatformBrowser } from '@angular/common';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {
  AuthService,
  IS_ACCOUNT_ACTIVE,
  IS_AUTHENTICATED,
  TOKEN,
  USERNAME,
} from '@/app/shared/services/auth.service';
import { VoucherService } from '@/app/shared/services/voucher.service';
import {
  ProductConditionDto,
  Voucher,
} from '@/app/shared/interface/voucher.interface';
import { ConfigurationV2Service } from '@/app/shared/services/configuration-v2.service';
import { TempCoinSource } from '@/app/shared/interface/order.interface';
import { useSafeTimeout } from '@/app/shared/ssr-util';
import { SearchSuggestionService } from '@/app/shared/services/search-suggestion.service';
import { TrackingService } from '@/app/shared/services/tracking.service';
import { SuggestionView, suggestionCount, toSuggestionView } from '@/app/shared/widgets/search-suggestions/search-suggestion-view';

declare var $: any;

@Component({
  selector: 'quick-order',
  templateUrl: './quick-order.component.html',
  styleUrls: ['./quick-order.component.scss'],
})
export class QuickOrderComponent {
  @Output() productLabel: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('voucherModal', { static: false }) voucherModal: any;

  public breadcrumb: Breadcrumb = {
    title: 'Đặt Nhanh',
    items: [{ label: 'Đặt Nhanh', active: true }],
  };
  public skeletonLoader: boolean = false;
  public loaderStatus: boolean = false;
  public skeletonItems = Array.from({ length: 40 }, (_, index) => index);

  vouchers: Voucher[] = [];
  public items: any[] = [];
  public itemsExtend: any[] = [];
  public cartTotalItems: number = 0;
  public sumTotalPrice: number = 0;
  public inputText: string;
  public bodyExtractSearch = {
    limit: 20,
    searchTerm: '',
  };

  public cart: Cart;
  public cartItem: CartItem;
  Math = Math;

  public pagination: Paginate;
  _currentPage: number = 1;
  _paginateRange: number = 7;
  bodyProduct = {
    limit: 20,
    offset: 0,
  };
  banners: any[] = [];

  @Input() selectedVoucherCode: string[] = [];

  // TODO: Using configuration for branding filter
  public filters = [
    {
      name: 'Tất cả',
      active: true,
      value: '',
      slug: '',
      fetch: this.fetchingDataProcessor,
    },
    {
      name: 'Giảm giá sốc',
      active: false,
      value: '4',
      icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI2ZmOTgwMCIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJNMTIgMmwyLjQgNy4yTDIyIDEybC03LjYgMi44TDEyIDIybC0yLjQtNy4yTDIgMTJsNy42LTIuOHoiIC8+PC9zdmc+',
      slug: 'giam-gia-soc',
      fetch: () => this.getProductsByCriteria({ labels: ['giam-gia-soc'], sortBy: 'price-difference' }),
    },
    {
      name: 'Combo Tiết Kiệm',
      active: false,
      value: '1',
      icon: 'assets/svg/hot.svg',
      slug: 'combo-tiet-kiem',
      fetch: () => this.getProductsByCriteria({ labels: ['combo-tiet-kiem'] }),
    },
    {
      name: 'Sản phẩm Giga Germany',
      active: false,
      value: '5',
      icon: 'assets/svg/hot.svg',
      slug: 'giga-germany',
      fetch: () => this.getProductsByCriteria({ labels: ['giga-germany'] }),
    },
    {
      name: 'Sản phẩm Vidipha',
      active: false,
      value: '3',
      icon: 'assets/svg/hot.svg',
      slug: 'Vidipha',
      fetch: () => this.getProductsByCriteria({ manufacturer: 'Vidipha' }),
    },
    {
      name: 'Sản Phẩm Dược Hậu Giang',
      active: false,
      value: '1',
      icon: 'assets/svg/hot.svg',
      slug: 'sp-dhg',
      fetch: () => this.getProductsByCriteria({ labels: ['sp-dhg'] }),
    },
    {
      name: 'Sản phẩm United',
      active: false,
      value: '1',
      icon: 'assets/svg/hot.svg',
      slug: 'united',
      fetch: () => this.getProductsByCriteria({ labels: ['united'] }),
    },
    {
      name: 'Sản phẩm Alpha Choay',
      active: false,
      value: '3',
      icon: 'assets/svg/hot.svg',
      slug: 'alpha-choay',
      fetch: () => {
        this.inputText = 'Alpha choay';
        this.searchSubject.next(this.inputText);
      },
    },
    {
      name: 'Sản phẩm Santen',
      active: false,
      value: '1',
      icon: 'assets/svg/hot.svg',
      slug: 'santen',
      fetch: () => this.getProductsByCriteria({ manufacturer: 'Santen' }),
    },
  ];

  tagIcons = {
    vat: 'assets/svg/product/freeship-label1.svg',
    docQuyen:
      'https://s3.ap-southeast-1.amazonaws.com/ecrms-appfiles/homeconfig/configuration/20250729_044737_457.webp',
    khuyenMai: 'assets/svg/gift/promo_voucher1.svg',
    haugiang:
      'https://s3.ap-southeast-1.amazonaws.com/ecrms-appfiles/homeconfig/configuration/20250725_083853_344.webp',
  };
  currentTab: string = '';

  public views: number = 1524;

  private searchSubject = new Subject<string>();
  private readonly debounceTimeMs = 500; // Set the debounce time (in milliseconds)

  private changeQueryStringSubcription?: Subscription;
  public searchUserQuery: SearchUserQueryString = new SearchUserQueryString();
  public categoryQuery: CatetoryQueryString = new CatetoryQueryString();
  public labelQuery: LabelQueryString = new LabelQueryString();
  public pageQueryString: PageQueryString = new PageQueryString();
  public isAuthenticated: boolean;
  public isAccountActivated: boolean;

  // wishlist
  wishlistIds: number[] = [];
  inWishList: boolean = false;

  // modal
  public title: string = '';
  public imageUrls: string[] = [];
  private routerEvent: Subscription;
  // cartItemsMap: Map<number, CartItem> = new Map();

  isBrowser: boolean = false;
  isVipCustomer: boolean = false;

  productVouchers: Voucher[] = [];
  productVoucherMap: Record<string, Voucher[]> = {};

  progressData: any[] = [];
  currentValue: number = 0;
  additionalCoins: number = 0;
  additionalRankingCoins?: {
    value: number;
    label: string;
    remainingToNext: number;
    nextLabel: string;
  }[] = [];
  additionalTempCoins?: {
    reference: string;
    tempCoinSource: TempCoinSource;
    value: number;
    label: string;
  }[] = [];
  isExceededMinimumMilestone: boolean = false;

  cartSubscription: Subscription;
  updateFromView: boolean = false;

  firstTimeLoadCart: boolean = true;

  bestSellerMenuClickSubscription: Subscription;

  private safeTimeout = useSafeTimeout();

  /** Gợi ý tìm kiếm (bảng map từ khóa / sản phẩm thay thế) của từ khóa đang tìm; null khi chưa có, rỗng hay lỗi. */
  public suggestion: SuggestionView | null = null;
  /** Tăng mỗi lần tìm mới: phản hồi gợi ý của lần tìm cũ về muộn thì bị bỏ. */
  private suggestionRun = 0;
  /** Đã gọi API gợi ý, chưa có phản hồi: chưa có gì để hiện thì hiện skeleton, không báo "Không tìm thấy". */
  public suggestionPending = false;

  constructor(
    public productService: ProductService,
    private route: ActivatedRoute,
    public router: Router,
    private commonService: CommonService,
    private queryStringService: QueryStringService,
    private flashSaleService: FlashSaleService,
    private wishlistService: WishlistService,
    private toastService: ToastrService,
    private accountService: AccountService,
    private cookieService: SsrCookieService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private transferState: TransferState,
    private authService: AuthService,
    private voucherService: VoucherService,
    private configurationV2Service: ConfigurationV2Service,
    private searchSuggestionService: SearchSuggestionService,
    private tracking: TrackingService,
  ) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (isPlatformBrowser(this.platformId)) {
      // For SSR
      let number =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (number >= 98) {
        const headerHeight = $('.header-2').height();

        if (window.innerWidth < 800) {
          $('.left-col').removeClass('sticky');
          $('.left-col').addClass('sticky-mobile');
          $('.left-col.sticky-mobile').css('top', headerHeight + 'px');
        } else {
          $('.left-col').removeClass('sticky-mobile');
          $('.left-col').addClass('sticky');
          $('.left-col.sticky').css('top', headerHeight + 'px');
        }
      } else {
        $('.left-col').removeClass('sticky');
        $('.left-col').removeClass('sticky-mobile');
        $('.left-col').css('top', '0px');
      }
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
      this.isAuthenticated = this.authService.isAuthenticated();
      this.accountService.getUserData.subscribe((res) => {
        if (res && res.roles?.length) {
          this.isVipCustomer = res.roles.some((role) => role.roleName.toLowerCase() === 'vip' || role.roleName.toLowerCase() === 'khcl');
        }
      });
      if (!this.isAuthenticated) {
        this.router.navigate(['/auth/login']);
      }
      this.getVouchers();
      this.isAccountActivated = this.authService.isAccountActivated();
      this.categoryQuery = this.queryStringService.getQueryString(new CatetoryQueryString());
      this.pageQueryString = this.queryStringService.getQueryString(new PageQueryString());

      this.commonService.getWishlist.subscribe({
        next: (res: number[]) => {
          if (res && res.length > 0) {
            this.wishlistIds = res;
          }
        },
      });

      this.route.queryParams.subscribe(async (params) => {
        if (!this.updateFromView) {
          if (params['s']) {
            this.inputText = params['s'];
          }
          // set active UI
          this.setActiveFilterFromUrl();
          if (this.filters.every((f) => !f.active)) {
            this.filters[0].active = true;
            this.queryStringService.clearAllQueryStrings();
          }
          this.fetchingDataProcessor();
        } else {
          this.updateFromView = false;
        }
      });
      this.queryStringService.startFetchingData();
      this.searchSubject
        .pipe(debounceTime(this.debounceTimeMs))
        .subscribe((searchValue) => {
          this.searchUserQuery.value = this.inputText;
          // Suppress the echoed queryParams event from changeQueryString so fetch isn't skipped/duplicated.
          this.updateFromView = true;
          this.queryStringService.changeQueryString(this.searchUserQuery);
          this.fetchingDataProcessor();
        });

      this.routerEvent = this.router.events.subscribe({
        next: (val: any) => {
          if (val instanceof NavigationEnd) {
            if (this.router.url.includes('/quick-order')) {
              if (isPlatformBrowser(this.platformId)) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }
          }
        },
      });
      this.getExternalBanner();
    }
  }

  setActiveFilterFromUrl() {
    const params = this.route.snapshot.queryParams;
    const label = params['label'] || '';
    const manufacturer = params['manufacturer'] || '';

    for (const f of this.filters) {
      if (f.active)
        f.active = false;

      if (!label && !manufacturer && f.slug === this.currentTab) {
        f.active = true;
      }

      if (!label && !manufacturer && !this.currentTab && f.slug === 'all') {
        f.active = true;
      }

      if (label && f.slug === label) {
        f.active = true;
      }

      if (manufacturer && f.slug === manufacturer.toLowerCase()) {
        f.active = true;
      }
    }
  }

  async getProductsPagination(pageNumber?: number) {
    this.skeletonLoader = true;
    this.itemsExtend = [];

    // const token = this.cookieService.get('token');
    const token = this.cookieService.get('token');

    let res: any;

    if (token) {
      res = await firstValueFrom(this.productService.getProductsPaginationForMember(this.body));
    } else {
      res = await firstValueFrom(this.productService.getProductsPaginationforGuest(this.body))
    }

    if (res) {
      let self = this;
      self.itemsExtend = res.products;
      self.itemsExtend = self.itemsExtend.filter(
        (item) => !self.items.some((i) => i.id === item.id),
      );
      for (let item of self.itemsExtend) {
        item.currentTier = item.tieredPrices.find((x: any) => x.pricingTableId == item.appliedPricingTable.id);
        item.progressLabel = self.commonService.getProgressLabel(item);
      }

      // self.getRelevantVouchersForProduct(self.itemsExtend);

      let pagination: PaginationModel = {
        limit: self.body.limit,
        offset: self.body.offset,
        searchTerm: self.body.searchTerm,
        totalItems: res.total,
        sortBy: self.body.sortBy,
        category: '',
      };
      self.skeletonLoader = false;
      self.queryStringService.changePagination(pagination);
      self.updateCartItem();
    }
    this.getCart();
  }

  input() {
    // if (this.searchUserQuery.value != this.inputText) {
    //   this.skeletonLoader = true;
    //   this.items = [];
    //   this.searchSubject.next(this.inputText);
    // }

    this.skeletonLoader = true;
    // this.items = [];
    this.currentTab = '';
    this.searchSubject.next(this.inputText);
  }

  initCartItem(product: any) {
    let cartItem = {
      imgUrl: product.imageUrls[0],
      name: product.name,
      price: product.basePrice,
      basePrice: product.basePrice,
      productID: product.productID,
      quantity: 0,
      labels: product.labels,
      SKU: product.SKU,
      slug: product.slug,
      coinIconLevel: product.coinIconLevel,
      appliedPricingTable: product.appliedPricingTable,
    };

    return cartItem;
  }

  updateCartItem() {
    const apply = (product: Product) => {
      product.cartItem = this.initCartItem(product);

      for (let cartItem of this.cart?.items ?? []) {
        if (cartItem.previewPrice) {
          const findCartItem = cartItem.subItems?.find((item) => item.productID === product.productID);
          product.cartItem = structuredClone(findCartItem) ?? this.initCartItem(product);
          product.subProducts = cartItem?.subItems ?? [];
        }
        else {
          if (cartItem.productID === product.productID) {
            product.cartItem = structuredClone(cartItem) ?? this.initCartItem(product);
            product.subProducts = cartItem.subItems ?? [];
          }
        }
      }
    };

    this.items?.forEach(apply);
    this.itemsExtend?.forEach(apply);
    this.suggestion?.map?.products.forEach(apply);
    this.suggestion?.equivalent?.products.forEach(apply);
  }

  /** Kết quả tìm kiếm thường chỉ hiện khi gợi ý chưa chiếm hết một trang (limit): đã đủ limit thì không cần nữa. */
  get showNormalResults(): boolean {
    return suggestionCount(this.suggestion) < (this.defaultBody.limit ?? 20);
  }

  /** Skeleton khi đang tải; hoặc khi còn chờ gợi ý mà chưa có kết quả thường nào để hiện. */
  get showSkeleton(): boolean {
    return (this.skeletonLoader || (this.suggestionPending && !this.items.length)) && !this.itemsExtend.length;
  }

  /** Bấm "Xem tất cả" của phần map: tìm luôn từ khóa đích. */
  searchRewrite(term: string) {
    this.inputText = term;
    this.input();
  }

  /**
   * Gọi song song với tìm kiếm thường (không chờ, không làm chậm kết quả thường). Chỉ cho khách đã đăng nhập và trang đầu.
   * Có gợi ý thì chèn một mục phía trên và đẩy kết quả thường xuống; không có thì giao diện như cũ.
   */
  private loadSuggestion(term: string) {
    const run = this.suggestionRun;
    const startedAt = Date.now();
    this.suggestionPending = true;
    this.searchSuggestionService.get(term).subscribe((res) => {
      if (run !== this.suggestionRun) return;
      this.suggestionPending = false;
      const view = toSuggestionView(term, res, startedAt, this.tracking);
      if (!view) return;
      for (const product of [...(view.map?.products ?? []), ...(view.equivalent?.products ?? [])]) {
        product.progressLabel = this.commonService.getProgressLabel(product);
      }
      this.suggestion = view;
      this.updateCartItem();
    });
  }

  filterSelectedItemAlternative(ProductID: number) {
    var res = this.cart.items.find((item) => item.productID === ProductID);

    return res?.quantity ?? 0;
  }

  filter(e: any) {
    this.updateFromView = true;
    this.currentTab = e.slug;
    this.queryStringService.clearAllQueryStrings();
    let selected = this.filters.find((f) => f.active);
    // if (selected && e.slug === selected.slug) {
    //   return;
    // }
    this.changedMode = true;
    this.inputText = '';

    for (let f of this.filters) {
      if (f.slug != e.slug) {
        f.active = false;
      } else {
        f.active = true;
      }
    }

    if (typeof e.fetch === 'function') {
      e.fetch.call(this);
    }
  }

  getFlashSale() {
    this.skeletonLoader = true;
    this.flashSaleService.getFlashSale().subscribe({
      next: (res: any) => {
        if (res.currentPeriod) {
          this.items = res.currentPeriod.products.map((item: any) => {
            item.currentTier = item.tieredPrices.find((x: any) => x.pricingTableId == item.appliedPricingTable.id);
            item.progressLabel = this.commonService.getProgressLabel(item);
            return item;
          });
          let pagination: PaginationModel = {
            totalItems: res.currentPeriod.products.length,
          };
          this.queryStringService.changePagination(pagination);
        }
      },
      error: (error: any) => {
        console.error(error);
      },
      complete: () => {
        this.inputText = '';
        this.skeletonLoader = false;
        this.categoryQuery.value = '';
      },
    });
  }

  getProductsByCriteria(criteria: Partial<PaginationModel>) {
    let req: PaginationModel = criteria as PaginationModel;
    this.fetchingDataProcessor(req);
  }

  getWishlist() {
    let req: PaginationModel;
    if (this.wishlistIds.length) {
      req = {
        productIds: this.wishlistIds,
      } as PaginationModel;
    } else {
      req = {} as PaginationModel;
    }
    this.fetchingDataProcessor(req);
  }

  addToWishlist(id: number) {
    const body = {
      productId: id,
    };
    this.wishlistService.addWishlist(JSON.stringify(body)).subscribe({
      next: (res: number[]) => {
        if (res) {
          if (res.some((r) => r == id)) {
            this.toastService.success('Thêm vào danh sách yêu thích!', '', {
              positionClass: 'toast-top-right',
            });
          } else {
            this.toastService.success('Loại bỏ khỏi danh sách yêu thích!', '', {
              positionClass: 'toast-top-right',
            });
          }
          this.commonService.setWishlist(res);
          this.wishlistIds = res;
          if (this.currentTab == 'san-pham-yeu-thich') {
            this.getWishlist();
          }
        }
      },
      error: (error: any) => {
        this.toastService.error('Không thể cập nhật danh sách yêu thích!', '', {
          positionClass: 'toast-top-right',
        });
        console.error(error);
      },
    });
  }

  async getExternalBanner() {
    this.configurationV2Service.getExternalBannerInfo().subscribe({
      next: (res: any) => {
        if (res) {
          this.banners = res;
        }
      },
      error: (err) => {
        console.error('Error fetching external banner:', err);
        this.banners = [];
      },
    });
  }

  checkInWishlist(productId: number) {
    let inWishList = false;
    for (let id of this.wishlistIds) {
      if (id == productId) {
        inWishList = true;
        break;
      }
    }
    return inWishList;
  }

  openModal(index: number, item: Product, productDetailImageModal: any) {
    this.title = item.name;
    this.imageUrls = item.imageUrls;
    productDetailImageModal.openModal();
  }
  ngOnDestroy() {
    this.routerEvent?.unsubscribe();
    this.changeQueryStringSubcription?.unsubscribe();
    this.cartSubscription?.unsubscribe();
    this.bestSellerMenuClickSubscription?.unsubscribe();
  }

  queryStringBuilder(slug: string) {
    this.productLabel.emit(slug);
    this.router.navigate(['/product'], {
      queryParams: {
        label: slug,
      },
      queryParamsHandling: '',
    });
  }

  // createCartItemsMap(cartItems: CartItem[]): Map<number, CartItem> {
  //   const cartItemsMap = new Map<number, CartItem>();
  //   for (let item of cartItems) {
  //     cartItemsMap.set(item.productID, item);
  //   }
  //   return cartItemsMap;
  // }
  quantityAlternativeMap: Record<number, number> = {};
  getCart() {
    this.cartSubscription = this.commonService.getCart.subscribe({
      next: (res: Cart) => {
        if (res) {
          this.cart = structuredClone(res);
          this.quantityAlternativeMap = {};
          this.cart.items.forEach((item) => {
            if (!this.quantityAlternativeMap[item.productID]) {
              this.quantityAlternativeMap[item.productID] = item.quantity;
            } else {
              this.quantityAlternativeMap[item.productID] += item.quantity;
            }
          });

          const items: CartItem[] = res.items.map((item: any) => {
            item.SKU = item.SKU ?? item.sku;
            item.originalQuantity = item.quantity;
            return item;
          });

          const productIds = [
            ...new Set(res.items.map((item: any) => item.productID)),
          ];
          const newCartItems: CartItem[] = [];
          for (let id of productIds) {
            let cartItems = items.filter((i: any) => i.productID === id);
            if (cartItems && cartItems.length > 0) {
              const cartItem: CartItem = structuredClone(
                cartItems[cartItems.length - 1],
              );
              cartItem.originalQuantity = cartItem.quantity;
              cartItem.quantity = cartItems.reduce(
                (a: number, b: CartItem) => a + b.quantity,
                0,
              );
              cartItem.totalPriceSavingAmount = cartItems.reduce(
                (a: number, b: CartItem) => a + (b.totalPriceSavingAmount || 0),
                0,
              );
              cartItem.variantItems = cartItems;
              newCartItems.push(cartItem);
            }
          }

          this.cart.items = [...newCartItems];

          // Always map cartItem to products; when cart is empty this creates default cartItem.
          this.updateCartItem();

          if (this.cart.items.length == 0) {
            this.progressData = [];
            this.currentValue = 0;
            this.additionalCoins = 0;
            this.additionalRankingCoins = [];
            return;
          }

          // this.cartItemsMap = this.createCartItemsMap(this.cart.items);

          // setTimeout(() => {
          //   if (this.cart.coinMilestoneValues?.milestones.length > 0) {
          //     this.progressData =
          //       this.cart.coinMilestoneValues?.milestones || [];
          //     this.isExceededMinimumMilestone =
          //       this.cart.coinMilestoneValues.currentProgress >=
          //       this.cart.coinMilestoneValues.milestones[0].estimatedValue;
          //     if (this.isExceededMinimumMilestone) {
          //       this.additionalCoins =
          //         this.cart.estimatedReceiveTempCoin - this.currentValue;
          //       this.additionalRankingCoins =
          //         this.cart.estimatedTempCoinMilestones;
          //       this.additionalTempCoins = this.cart.estimatedTempCoinList;
          //       this.currentValue = this.cart.estimatedReceiveTempCoin;
          //       setTimeout(() => {
          //         this.commonService.animateProgress(
          //           this.additionalCoins,
          //           () => {
          //             this.commonService.setOdometer(this.currentValue);
          //           },
          //           this.firstTimeLoadCart,
          //         );
          //         this.firstTimeLoadCart = false;
          //       }, 500);
          //     } else {
          //       this.additionalCoins = -this.currentValue;
          //       this.currentValue = 0;
          //       setTimeout(() => {
          //         this.commonService.animateProgress(this.additionalCoins);
          //         this.commonService.setOdometer(this.currentValue);
          //       }, 200);
          //     }
          //   }
          // }, 1);
        }
      },
    });
  }

  private changedMode: boolean = false; // Indicated mode changed to reset body
  private defaultBody: PaginationModel = {
    limit: 20,
    offset: 0,
  } as PaginationModel; // Default body use for change tab
  private body: PaginationModel = {
    ...this.defaultBody,
  }; // Body - current pagination for selected tab

  async fetchingDataProcessor(orderBody?: PaginationModel) {
    this.items = [];
    this.itemsExtend = [];
    this.suggestion = null;
    this.suggestionPending = false;
    this.suggestionRun++;
    if (this.changedMode) {
      this.changedMode = false;
      this.body = {
        ...this.defaultBody,
      } as PaginationModel;
    } else {
      let body = this.queryStringService.buildFetchingModel();
      this.copyObjectValue(this.body, body);
    }
    if (orderBody) {
      this.copyObjectValue(this.body, orderBody);
    } else {
      this.body.searchTerm = this.inputText;
    }
    this.skeletonLoader = true;

    const token = this.cookieService.get('token');

    let res: any;
    let self = this;

    if (self.body.searchTerm) {
      if (token && !self.body.offset) {
        self.loadSuggestion(self.body.searchTerm);
      }
      if (token) {
        res = await firstValueFrom(self.productService.searchProductsForMember(JSON.stringify(self.body)));
      } else {
        res = await firstValueFrom(self.productService.searchProductsForGuest(JSON.stringify(self.body)));
      }

      if (res) {
        self.items = res.products;
        // self.getRelevantVouchersForProduct(self.items);

        for (let item of self.items) {
          item.currentTier = item.tieredPrices.find((x: any) => x.pricingTableId == item.appliedPricingTable?.id);
          item.progressLabel = self.commonService.getProgressLabel(item);
        }

        if (self.items.length < self.bodyExtractSearch.limit!) {
          self.body.searchTerm = '';
          await self.getProductsPagination();
        }
        else {
          self.body.totalItems = res.total;
          let pagination: PaginationModel = {
            limit: self.body.limit,
            offset: self.body.offset,
            searchTerm: self.body.searchTerm,
            totalItems: res.total,
            sortBy: self.body.sortBy,
            category: '',
          };

          self.queryStringService.changePagination(pagination);
        }

        self.updateCartItem();
      }
    }
    else {
      await self.getProductsPagination();
    }

    self.skeletonLoader = false;
    self.loaderStatus = false;
  }

  copyObjectValue(
    target: PaginationModel,
    source: PaginationModel | RetriveUserModel,
  ) {
    target.searchTerm = source.searchTerm;

    if (source.categories && source.categories.length) {
      target.categories = source.categories;
    }
    if (source.category) {
      target.category = source.category;
    }
    if (source.limit) {
      target.limit = source.limit;
    }
    if (source.offset) {
      target.offset = source.offset;
    } else {
      target.offset = 0;
    }

    if (source.labels && source.labels.length) {
      target.labels = source.labels;
    }

    if (source.productIds && source.productIds.length) {
      target.productIds = source.productIds;
    }

    if (source.tags && source.tags.length) {
      target.tags = source.tags;
    }
    if (source.sortBy) {
      target.sortBy = source.sortBy;
    }
    if (source.manufacturer) {
      target.manufacturer = source.manufacturer;
    }
  }

  getRelevantVouchersForProduct(items: Product[]): void {
    if (this.isAuthenticated) {
      const conditions: ProductConditionDto[] = [];

      for (const item of items) {
        if (item.sku) {
          conditions.push({ sku: item.sku });
        }

        const labels = item.labels ?? [];
        for (const label of labels) {
          if (label?.slug) {
            conditions.push({ label: label.slug });
          }
        }
      }

      if (!conditions.length) return;

      this.voucherService.getRelevantVoucherProducts(conditions).subscribe({
        next: (vouchers: Voucher[]) => {
          this.productVouchers = vouchers;
          this.productVoucherMap = {}; // Map theo SKU hoặc label

          for (const voucher of vouchers) {
            const pqConditions =
              voucher.voucherCondition?.productQuantityConditions ?? [];
            const labelConditions =
              voucher.voucherCondition?.applicableLabelQuantity ?? [];
            const labelCondition: string[] =
              voucher.voucherCondition?.applicableLabels ?? [];

            for (const cond of pqConditions) {
              const sku = cond?.sku;
              if (!sku) continue;

              if (!this.productVoucherMap[sku]) {
                this.productVoucherMap[sku] = [];
              }
              this.productVoucherMap[sku].push(voucher);
            }

            for (const lq of labelConditions) {
              const labelSlugs = lq?.labels;
              if (!labelSlugs) continue;

              if (!this.productVoucherMap[labelSlugs]) {
                this.productVoucherMap[labelSlugs] = [];
              }
              this.productVoucherMap[labelSlugs].push(voucher);
            }

            for (const label of labelCondition) {
              const labelSlug = label?.trim().toLowerCase();
              if (!labelSlug) continue;
              if (!this.productVoucherMap[labelSlug]) {
                this.productVoucherMap[labelSlug] = [];
              }
              this.productVoucherMap[labelSlug].push(voucher);
            }
          }
        },
        error: (err) => {
          console.error('Failed to fetch vouchers from items:', err);
        },
      });
    }
  }

  openVoucherModal(vouchers?: Voucher[], clickedCode?: string) {
    if (vouchers) {
      const codes = vouchers.map((v) => v.code);

      const uniqueCodes = clickedCode
        ? [clickedCode, ...codes.filter((code) => code !== clickedCode)]
        : codes;

      this.selectedVoucherCode = uniqueCodes;
    } else {
      this.selectedVoucherCode = [];
    }

    this.voucherModal.openModal();
  }

  getCombinedVouchers(item: any): Voucher[] {
    const sku = item?.sku;
    const labels = item?.labels ?? [];
    const seenCodes = new Set<string>();
    const result: Voucher[] = [];

    // Theo SKU
    if (sku && Array.isArray(this.productVoucherMap?.[sku])) {
      for (const v of this.productVoucherMap[sku]) {
        if (v?.code && !seenCodes.has(v.code)) {
          seenCodes.add(v.code);
          result.push(v);
        }
      }
    }

    // Theo label.slug
    for (const label of labels) {
      const slug = label?.slug;
      if (slug) {
        const vouchers = this.productVoucherMap[slug];
        if (Array.isArray(vouchers)) {
          for (const v of vouchers) {
            if (v?.code && !seenCodes.has(v.code)) {
              seenCodes.add(v.code);
              result.push(v);
            }
          }
        }
      }
    }
    const gttUnlimited = this.productVouchers.find(
      (v) => v.code === 'GTT-Unlimited',
    );
    if (gttUnlimited && !seenCodes.has(gttUnlimited.code)) {
      seenCodes.add(gttUnlimited.code);
      result.push(gttUnlimited);
    }

    return result;
  }

  getVouchers() {
    this.voucherService.availableVouchers$.subscribe({
      next: (res: Voucher[]) => {
        if (!res || !Array.isArray(res)) {
          return;
        }
        this.vouchers = res.filter((v) => !!v.voucherCondition);
      },
      error: (error: any) => {
        console.log(error);
      },
      complete: () => {
        this.skeletonLoader = false;
      },
    });
  }

  hasTag(item: any, tagSlug: string): boolean {
    return item.labels?.some((l: any) => l.slug === tagSlug);
  }

  isPromotionalProduct(item: any): boolean {
    if (!item || !this.vouchers?.length) return false;
    const productLabelSlugs = item.labels?.map((l: any) => l.slug) ?? [];
    const productSku = String(item?.sku ?? '');
    const categoryIds = item.categories?.map((c: any) => c.categoryId) ?? [];

    for (const voucher of this.vouchers) {
      const condition = voucher.voucherCondition;
      if (!condition) continue;

      const labelQtyConditions = condition.applicableLabelQuantity ?? [];
      for (const cond of labelQtyConditions) {
        if (!cond?.labels?.length) continue;
        const condLabels = Array.isArray(cond.labels)
          ? cond.labels
          : [cond.labels];
        if (
          condLabels.some((slug: string) => productLabelSlugs.includes(slug))
        ) {
          return true;
        }
      }

      const applicableLabels = condition.applicableLabels ?? [];
      if (
        applicableLabels.some((slug: string) =>
          productLabelSlugs.includes(slug),
        )
      ) {
        return true;
      }

      const productQtyConditions = condition.productQuantityConditions ?? [];
      if (
        productQtyConditions.some(
          (cond: any) => String(cond?.sku ?? '') === productSku,
        )
      ) {
        return true;
      }

      const applicableCategoryIds = condition.applicableCategoryIds ?? [];
      if (
        applicableCategoryIds.some((cid: string) => categoryIds.includes(cid))
      ) {
        return true;
      }
      const categoryQtyConditions = condition.applicableCategoryQuantity ?? [];
      if (
        categoryQtyConditions.some((cond: any) =>
          categoryIds.includes(cond.categoryId),
        )
      ) {
        return true;
      }
    }
    return false;
  }

  getPromotionalLabelSlug(item: any): string | null {
    if (!item || !this.vouchers?.length) return null;

    const productLabelSlugs = (item.labels ?? [])
      .map((l: any) => l.slug)
      .filter((slug: any): slug is string => typeof slug === 'string');

    for (const voucher of this.vouchers) {
      const condition = voucher.voucherCondition;
      if (!condition) continue;

      const labelQtyConditions = condition.applicableLabelQuantity ?? [];
      for (const cond of labelQtyConditions) {
        const condLabels = Array.isArray(cond?.labels)
          ? cond.labels
          : [cond?.labels];
        const matched = condLabels.find((slug: string) =>
          productLabelSlugs.includes(slug),
        );
        if (matched) return matched;
      }

      const applicableLabels = condition.applicableLabels ?? [];
      const matched = applicableLabels.find((slug: string) =>
        productLabelSlugs.includes(slug),
      );
      if (matched) return matched;
    }

    return null;
  }

  onClickPromoLabel(item: any): void {
    const slug = this.getPromotionalLabelSlug(item);
    if (slug) {
      this.queryStringBuilder(slug);
    }
  }

  gotoBlog() {
    this.commonService.gotoLink();
  }

  tagCount(item: any): number {
    let count = 0;
    if (this.hasTag(item, 'san-pham-doc-quyen')) count++;
    if (this.isPromotionalProduct(item)) count++;
    return count;
  }
}
